export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Progressively formats digits as (555) 123-4567 while the user types. */
export function formatPhoneNumber(value) {
	const digits = value.replace(/\D/g, "").slice(0, 10);
	if (digits.length === 0) return "";
	if (digits.length < 4) return `(${digits}`;
	if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isValidPhone(value) {
	return value.replace(/\D/g, "").length === 10;
}

export function isValidUrl(value) {
	try {
		return /^https?:$/.test(new URL(value).protocol);
	} catch (e) {
		return false;
	}
}

export function formatMoney(amount) {
	return "$" + amount.toLocaleString("en-US");
}

export const US_STATES = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
